import { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import RoundedProfilePicture from "../../front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";
import { dateAndTimeConverter } from "../../front-end-global-components/utils/constants";
import { getPatientTokenHistory } from "../../redux/abdm/actions";

function TokenHistory(props) {
  const navigate = useNavigate();

  useEffect(() => {
    getPatientTokenHistory();
  }, []);

  return (
    <>
      <Header
        hideSupport={true}
        title="Check-in tokens"
        backButtonOnClick={() => {
          navigate("/settings");
        }}
      />

      {props.app?.featureFlags?.healthData ? (
        <>
          {props.abdm.loading ? (
            <div className="padding-larger">
              <Shimmer />
            </div>
          ) : (
            <div
              style={{ height: "calc(100% - 64px)" }}
              className="padding-larger overflow-scroll hide-scroll-bar"
            >
              {props.abdm?.tokenHistory?.length > 0 ? (
                props.abdm?.tokenHistory?.map((d, i) => (
                  <div key={i}>
                    <Card data={d} />
                  </div>
                ))
              ) : (
                <div
                  style={{ height: "calc(100% - 64px)" }}
                  className="display-flex flex-justify-content-center flex-align-items-center flex-direction-column"
                >
                  <div className="font-family-aldrich-regular text-align-center">
                    No check-in tokens found
                  </div>
                  <div className="padding-top-large text-align-center font-size-small">
                    You don’t have any check-in tokens at the moment.
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      ) : (
        <FeatureFlagsFallback height="remaining-body-height" />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  abdm: state.abdm,
  app: state.app
});

export default connect(mapStateToProps)(TokenHistory);

const Card = (props) => {
  return (
    <div className="padding-bottom-larger">
      <div className="display-flex flex-align-items-center">
        <RoundedProfilePicture
          userType="corporate"
          src={props.logoURL}
          size="small"
        />
        <div className="padding-left-large">
          <div
            style={{
              fontWeight: "bold"
            }}
            className=""
          >
            {props.data?.hipName}
          </div>
          <div className="padding-top-small font-size-small">
            {props.data?.hipId}
          </div>
        </div>
      </div>

      <div className="padding-top-large">
        {[
          { title: "TOKEN NUMBER", value: props.data?.tokenNumber },
          { title: "COUNTER", value: props.data?.counterCode },
          {
            title: "BOOKED AT",
            value: `${dateAndTimeConverter(
              +new Date(props?.data?.dateCreated),
              "cardDateWithoutDay"
            )}, ${dateAndTimeConverter(
              +new Date(props?.data?.dateCreated),
              "Time"
            )}`
          },
          {
            title: "EXPIRES AT",
            value: `${dateAndTimeConverter(
              +new Date(props?.data?.dateCreated),
              "cardDateWithoutDay"
            )}, ${dateAndTimeConverter(
              +new Date(props?.data?.dateCreated).getTime() + 3600 * 1000,
              "Time"
            )}`
          }
        ].map((data, i) => (
          <div
            key={i}
            className="display-flex flex-justify-content-space-between"
          >
            <div className="font-size-small padding-bottom-default">
              {data?.title} :
            </div>
            <div
              style={{
                fontWeight: "bold"
              }}
              className="font-size-small"
            >
              {data?.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Shimmer = () => {
  return (
    <article>
      <div className="inherit-parent-width">
        {[...Array(4).keys()].map((index) => (
          <div
            className="display-flex flex-direction-column margin-bottom-larger"
            key={index}
          >
            <div className="shimmer inherit-parent-width padding-large" />
            <div className="shimmer width-50-percentage padding-medium margin-top-default" />
          </div>
        ))}
      </div>
    </article>
  );
};
